import React from "react";
import { Box, Grid } from "@mui/material";
import { Button, TextLink, TextLinkCaret } from "@vds/buttons";
import { signInConfig } from "../../global/utility/Utils";
import peopleCountImg from "./../../assets/peoplecount-img.png";
import peopleCountImg2 from "./../../assets/peoplecount-img-2.png";
import objectDetectionImg from "./../../assets/objectdetection-img.png";
import verizonBizLogo from "./../../assets/VerizonBusiness_GlowWordmark_RGB 1.png";
import { Body, Title } from "@vds/typography";

const insightsImages = [peopleCountImg, peopleCountImg2, objectDetectionImg];

const FiveGVideoInsightsPage = () => {
  const handleLinkClick = (isCalifornia) => {
    if (isCalifornia) {
    } else {
    }
  };
  const handleLoginClick = (isBusiness) => {
    sessionStorage.clear();
    if (
      window.location.pathname !== "/login" &&
      window.location.pathname !== "/dashboard"
    ) {
      const path = window.location.pathname + window.location.search;
      const isRelativePath = path.startsWith("/") && !path.startsWith("//");
      if (isRelativePath) {
        sessionStorage.setItem("rurl", path);
      }
    }
    let signInUrl = isBusiness
      ? signInConfig.oidc_provider.authorization_endpoint +
        `?` +
        `client_id=${signInConfig.client_credentials.client_id}&` +
        `redirect_uri=${signInConfig.client_credentials.redirect_uri}&` +
        `scope=${signInConfig.scopes}&` +
        `response_type=code&` +
        `kc_idp_hint=${signInConfig.oidc_provider.kc_idp_hint}`
      : signInConfig.oidc_provider.authorization_endpoint +
        `?` +
        `client_id=${signInConfig.client_credentials.client_id}&` +
        `redirect_uri=${signInConfig.client_credentials.redirect_uri}&` +
        `scope=${signInConfig.scopes}&` +
        `response_type=code`;
    window.location.replace(signInUrl);
  };
  return (
    <Grid container sx={{ minHeight: "100vh" }}>
      {/* Left Section */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: "#000",
          position: "relative",
          color: "#fff",
          p: { xs: 4, md: 8 },
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Box
          component="img"
          src={verizonBizLogo}
          alt="Verizon Business Logo"
          sx={{
            position: "absolute",
            top: 24,
            left: 24,
            width: 120,
            height: "auto",
          }}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            gap: "16px",
          }}
        >
          <Title size="large" color="#FFFFFF" bold>
            5G Video Insights
          </Title>
          <Body size="medium" bold color="#FFFFFF">
            <span style={{ textAlign: "center" }}>
              <span style={{ color: "yellow" }}>
                Deploy, manage, and scale with AI
              </span>{" "}
              for your physical operations and transform your cameras with
              out-of-the-box applications.
            </span>
          </Body>

          <Box sx={{ display: "flex", gap: 2, mt: 2, flexWrap: "wrap" }}>
            {insightsImages.map((src, index) => (
              <Box
                key={index}
                component="img"
                src={src}
                alt={`insight-${index}`}
                sx={{
                  height: "80px",
                  objectFit: "cover",
                }}
              />
            ))}
          </Box>
        </Box>
      </Grid>

      {/* Right Section */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: "#f9f9f9",
          p: { xs: 4, md: 8 },
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          gap: "20px",
        }}
      >
        {/* <Button
          variant="contained"
          sx={{
            backgroundColor: "#000",
            color: "#fff",
            px: 6,
            py: 1.5,
            mb: 2,
            "&:hover": {
              backgroundColor: "#222",
            },
          }}
        >
          Log in
        </Button> */}
        <Button
          type="primary"
          className="login-pageButton"
          align={"center"}
          width={"full"}
          onClick={() => handleLoginClick(false)}
          // disabled={errorText === "Invalid account type"}
        >
          Login
        </Button>

        {/* <Link href="#" underline="hover" sx={{ mb: 2 }}>
          Log in using a Verizon My Business account
        </Link> */}
        <Box>
          <TextLink
            size="medium"
            type="standAlone"
            surface="light"
            disabled={false}
            onClick={() => handleLoginClick(true)}
          >
            Log in using a Verizon My Business account
          </TextLink>
        </Box>

        <Box sx={{ marginTop: "8px", textAlign: "center" }}>
          <Body size="small" color="#A7A7A7">
            By continuing, you agree to the{" "}
            <TextLink
              size="small"
              type="standAlone"
              surface="light"
              disabled={false}
              onClick={() => handleLinkClick(false)}
            >
              <span style={{ fontSize: 14 }}>Privacy policy</span>
            </TextLink>{" "}
            and{" "}
            <TextLink
              size="small"
              type="standAlone"
              disabled={false}
              onClick={() => handleLinkClick(true)}
            >
              <span style={{ fontSize: 14 }}>California privacy policy</span>
            </TextLink>
            .
          </Body>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FiveGVideoInsightsPage;
